module.exports = __webpack_public_path__ + "img/phone-vector2.d46297ee.svg";